__turbopack_context__.v({
  "checkboxCondensed": "ColourRefinement-module-scss-module__G_EILG__checkboxCondensed",
  "clearFilterButton": "ColourRefinement-module-scss-module__G_EILG__clearFilterButton",
  "clearFilterDisplayed": "ColourRefinement-module-scss-module__G_EILG__clearFilterDisplayed",
  "clearFilterItem": "ColourRefinement-module-scss-module__G_EILG__clearFilterItem",
  "colourSwatch": "ColourRefinement-module-scss-module__G_EILG__colourSwatch",
  "condensedSwatch": "ColourRefinement-module-scss-module__G_EILG__condensedSwatch",
  "descriptionLabel": "ColourRefinement-module-scss-module__G_EILG__descriptionLabel",
  "isSelected": "ColourRefinement-module-scss-module__G_EILG__isSelected",
  "refinementListCheckbox": "ColourRefinement-module-scss-module__G_EILG__refinementListCheckbox",
  "refinementListCount": "ColourRefinement-module-scss-module__G_EILG__refinementListCount",
  "refinementListItem": "ColourRefinement-module-scss-module__G_EILG__refinementListItem",
  "refinementListLabel": "ColourRefinement-module-scss-module__G_EILG__refinementListLabel",
  "refinementListLabelText": "ColourRefinement-module-scss-module__G_EILG__refinementListLabelText",
  "refinementListList": "ColourRefinement-module-scss-module__G_EILG__refinementListList",
  "refinementListRoot": "ColourRefinement-module-scss-module__G_EILG__refinementListRoot",
  "swatchListCondensed": "ColourRefinement-module-scss-module__G_EILG__swatchListCondensed",
});
